var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "div",
      [
        _vm._t("default", function () {
          return [
            _c(
              "b-button",
              {
                attrs: { icon: "arrow-up", type: "is-info", size: "is-small" },
                on: { click: _vm.openChatModal },
              },
              [_vm._v("פתח צ'אט")]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }